import { useUserReviewsInitialData } from '@/scopes/products/user-reviews/hooks'
import { List } from './List'
import { ListLoading } from './ListLoading'

export function Reviews() {
  const { isLoading, reviews } = useUserReviewsInitialData()

  if (isLoading) {
    return <ListLoading amount={2} />
  }

  return <List reviews={reviews} />
}
